import { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  ScrollRestoration,
  Outlet,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import PageInicial from "./pages/home";
import PageSejaUmParceiro from "./pages/seja-parceiro";
import PageFaleConosco from "./pages/fale-conosco";
import PageTrabalheConosco from "./pages/trabalhe-conosco";
import PageSobreSifat from "./pages/sobre-sifat";
import PageSobreWaybe from "./pages/sobre-waybe";
import PageSobreProdati from "./pages/sobre-prodati";
import PageWaychef from "./pages/waychef";
import PageWaiter from "./pages/waiter";
import PageEfex from "./pages/efex";
import PageFlutt from "./pages/flutt";
import PageLumien from "./pages/lumien";
import PageWaymenu from "./pages/waymenu";
import PageWaypay from "./pages/waypay";
import PageWayservice from "./pages/wayservice";
import PagePrivacidade from "./pages/privacidade";
import PageConfirmacao from "./pages/confirmacao-newsletter";
import PagePesquisa from "./pages/pesquisa";
import AOS from "aos";
import "aos/dist/aos.css";
import PaginaAcessoRemoto from "./pages/acesso-remoto";
import PageBling from "./pages/bling";
import Page404 from "./pages/not-found";
AOS.init();

const AppLayout = () => (
  <>
    <ScrollRestoration />
    <Outlet />
    <ToastContainer />
  </>
);

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <PageInicial />,
      },
      {
        path: "/trabalhe-conosco",
        element: <PageTrabalheConosco />,
      },
      {
        path: "/fale-conosco",
        element: <PageFaleConosco />,
      },
      {
        path: "/integrador",
        element: <PageSejaUmParceiro />,
      },
      {
        path: "/quem-somos",
        element: <PageSobreWaybe />,
      },
      {
        path: "/quem-somos-prodati",
        element: <PageSobreProdati />,
      },
      {
        path: "/quem-somos-sifat",
        element: <PageSobreSifat />,
      },
      {
        path: "/waychef",
        element: <PageWaychef />,
      },
      {
        path: "/waiter",
        element: <PageWaiter />,
      },
      {
        path: "/efex-pdv",
        element: <PageEfex />,
      },
      {
        path: "/sifat-flutt",
        element: <PageFlutt />,
      },
      {
        path: "/sifat-lumien",
        element: <PageLumien />,
      },
      {
        path: "/waymenu",
        element: <PageWaymenu />,
      },
      {
        path: "/politica-de-privacidade",
        element: <PagePrivacidade />,
      },
      {
        path: "/waypay",
        element: <PageWaypay />,
      },
      {
        path: "/wayservice",
        element: <PageWayservice />,
      },
      {
        path: "/confirmacao",
        element: <PageConfirmacao />,
      },
      {
        path: "/pesquisa",
        element: <PagePesquisa />,
      },
      {
        path: "/acesso-remoto",
        element: <PaginaAcessoRemoto />,
      },
      {
        path: "/bling",
        element: <PageBling />,
      },
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
]);

function App() {
  useEffect(() => {
    document.title = "Sifat Sistemas - Sistema para automação comercial";
  }, []);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
